const env = import.meta.env as unknown as MyEnv

interface MyEnv {
  VITE_APP_ENV: string;
  VITE_APP_API_URL: string;
  VITE_APP_SENTRY_DSN: string;
  VITE_APP_GOOGLE_API_KEY: string;
  // Add other environment variables here if needed
}

if (!env.VITE_APP_ENV) {
  throw new Error('VITE_APP_ENV required from env')
}
if (!env.VITE_APP_GOOGLE_API_KEY) {
  throw new Error('VITE_APP_GOOGLE_API_KEY required from env')
}

export const config = {
  env: env.VITE_APP_ENV,
  apiUrl: env.VITE_APP_API_URL,
  sentryDsn: env.VITE_APP_SENTRY_DSN,
  googleApiKey: env.VITE_APP_GOOGLE_API_KEY,
  alerts: Boolean(env.VITE_APP_ENV === 'production' && env.VITE_APP_SENTRY_DSN?.length > 0)
}
